/* eslint-disable @typescript-eslint/ban-types */
import QueryTags from '../types/QueryTags'
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions'
import { BaseQueryFn, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query/react'



const basePath = '/membership/specifications'

const specificationsEndpoints = (builder: EndpointBuilder<
  BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>, QueryTags, 'data'>) =>
({
  fetchSpecifications: builder.query<any, string>({
    query: () => ({
      url: `${basePath}`,
      method: 'get',
    }),
    providesTags: ['specifications'],
  }),

  createSpecification: builder.mutation<any, any>({
    query: (body) => ({
      url: `${basePath}`,
      method: 'post',
      body,
    }),
    invalidatesTags: ['specifications'],
  }),

  deleteSpecificationSettings: builder.mutation<any, any>({
    query: (id) => ({
      url: `${basePath}/${id}`,
      method: 'delete',
    }),
    invalidatesTags: ['specifications'],
  }),

  updateSpecification: builder.mutation<any, any>({
    query: ({ id, body }) => ({
      url: `${basePath}/${id}`,
      method: 'PUT',
      body,
    }),
    invalidatesTags: ['specifications'],
  }),

})

export default specificationsEndpoints



